import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {FITH2Helper} from "../utils/FITH2Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class FITH2Logo extends PIXI.Container implements StageLayer {
    private readonly GAME_gameLogoOnTop_POSITION_Y: number[] = [53, -150, -200];
    private _gameLogoOnTop: PIXI.Sprite;
    private _logoAnimation: TimelineSprite;
    private _gameLogoPortraitPositionY: number;

    private _isIdling: boolean = false;
    private _isFS: boolean = false;
    private _idleAnimationPlaying: boolean = false;

    private _startDelay: number = 15;
    private _intervalRange: [number, number] = [10, 30];
    private _idleTl: gsap.core.Timeline | null;
    constructor() {
        super();
        this.name = "ReelFrame";
        this._isIdling = false;
        this.init();
    }

    private init() {
        this._gameLogoOnTop =new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("logo")[0]);
        this._gameLogoOnTop.name = "logo";
        this._gameLogoOnTop.anchor.set(0.5);
        this._gameLogoOnTop.position.set(0, 0);
        this._isFS = !FireInTheHole2.model.isNormal;
        //this._logoAnimation = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("logo_eff/logo_eff_"));
        //this._logoAnimation.hide();
        //this._logoAnimation.anchor.set(0.5);
        //this._logoAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        //this.addChild(this._logoAnimation);

        this._gameLogoPortraitPositionY = this.GAME_gameLogoOnTop_POSITION_Y[FireInTheHole2.model.isNormal ? 1 : 2];
        this.addChild(this._gameLogoOnTop);
        this.onResize();
    }

    public onResize(): void {
        this.onRePositionLogo();
    }

    public setMode(mode: string): void {
        if (FITH2Helper.isNormal(mode)) {
            this._isFS = false;
            this._gameLogoPortraitPositionY = this.GAME_gameLogoOnTop_POSITION_Y[1];
        } else {
            this._isFS = true;
            this._gameLogoPortraitPositionY = this.GAME_gameLogoOnTop_POSITION_Y[2];
        }
        this.onRePositionLogo();
    }

    public onRePositionLogo():void {
        const topSpace: number = (NolimitApplication.screenBounds.height - 720) / 2,
            isLandscape: boolean =  NolimitApplication.isLandscape,
            logoHeight: number = this._gameLogoOnTop.height,
            scaleTo:number = Math.max(0.5, MathHelper.roundToDecimals(topSpace / logoHeight, 1));
        this._gameLogoOnTop.scale.set(Math.min(1, scaleTo));
        // this._logoAnimation.scale.set(1.4);
        this.position.set(isLandscape?630:360, -topSpace*0.5 +  this._gameLogoOnTop.height*(isLandscape?0.5:0.4));
        // if (!isVisible && this._logoAnimation.visible) {
        //     this._logoAnimation.hide();
        // }
    }

    public playIdleAnimation(): void {
        if (!this._isIdling) {
            return;
        }
        this._idleAnimationPlaying = true;
        this._idleTl = gsap.timeline();
        this._idleTl!.add(() => this.playLogoAnimation(), MathHelper.randomNumberInRange(this._intervalRange[0], this._intervalRange[1], 2));
    }

    public startIdle(): void {
        if (this._isIdling) {
            return;
        }

        this._isIdling = true;
        this._idleTl = gsap.timeline();
        this._idleTl!.add(() => {
            this.playIdleAnimation();
        }, this._startDelay);
    }

    public stopIdle(): void {
        this._isIdling = false;
        if (this._idleTl) {
            this._idleTl.pause();
            this._idleTl.kill();
        }

        this._idleTl = null;
        if (this._idleAnimationPlaying) {
            this._idleAnimationPlaying = false;
        }
    }

    public playLogoAnimation(): void {
        return;
        if (this._gameLogoOnTop.visible) {
            this._logoAnimation.getAnimationAutoShowHide(true, true);
        }
    }
}